import { DialogService, GridButton } from '@eforall/dashboard';
import { DialogMode } from '@interfaces';
import { GoalEditorDialog, GoalEditorDialogData } from '../../../../../../../ui/widget';
import { AcceleratorAreaService } from '../../../../accelerator-area.service';


export function getButtons(dialogService: DialogService, areaService: AcceleratorAreaService) {

	const buttons: GridButton[] = [];

	const addGoalButton: GridButton = {
		iconClass: 'fa-plus',
		label: 'Add Goal',
		execute: async () => {
			const dialogData: GoalEditorDialogData = {
				mode: DialogMode.ADD,
				ventures: areaService.data()?.ventures.map(v => ({
					ventureId: v.accVentureId,
					ventureName: v.ventureName
				})) ?? []
			};
			await dialogService.showCustom<GoalEditorDialog, GoalEditorDialogData>(GoalEditorDialog, { data: dialogData }, 650, 650);
			await areaService.reloadData();
		}
	};

	if (areaService.canEdit()) {
		buttons.push(addGoalButton);
	}

	return buttons;
}